import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Spinner, Card, InputGroup } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { Get, Post, Put } from '../../../../utils/httpProvider';
import { CONGBOTHONGTIN_API } from '../../../../utils/apiUrl';
import { loaiDanhGiaValue } from '../../../../utils/define';
import moment from 'moment';

const CongBoThongTinForm = ({ baoVeCapVienId, readOnly = false, isUserView = false }) => {
    const [saving, setSaving] = useState(false);
    
    const [congBoThongTinId, setCongBoThongTinId] = useState(null);
    const [ketQua, setKetQua] = useState(loaiDanhGiaValue.dat);
    
    // Web cơ sở đào tạo
    const [ngayDangCSDT, setNgayDangCSDT] = useState('');
    const [truocSoNgayCSDT, setTruocSoNgayCSDT] = useState('');
    const [linkDangTaiCSDT, setLinkDangTaiCSDT] = useState('');

    // Báo Quân đội nhân dân
    const [ngayDangQDND, setNgayDangQDND] = useState('');
    const [truocSoNgayQDND, setTruocSoNgayQDND] = useState('');
    const [linkDangTaiQDND, setLinkDangTaiQDND] = useState('');

    const { data: queryRes, refetch, isLoading } = useQuery(
        ['congBoThongTinData', baoVeCapVienId], 
        () => Get(`${CONGBOTHONGTIN_API.GET_BY_BAOVECAPVIEN_ID}/${baoVeCapVienId}`),
        { 
            enabled: !!baoVeCapVienId,
            refetchOnWindowFocus: false 
        }
    );

    useEffect(() => {
        if (queryRes) {
            let item = null;
            if (Array.isArray(queryRes)) {
                item = queryRes[0];
            } else if (queryRes.data && Array.isArray(queryRes.data)) {
                item = queryRes.data[0];
            } else if (queryRes.data?.$values) {
                item = queryRes.data.$values[0];
            } else if (queryRes.data) {
                item = queryRes.data;
            } else {
                item = queryRes;
            }

            if (item && item.id) {
                setCongBoThongTinId(item.id);
                setKetQua(item.ketQua || loaiDanhGiaValue.dat);
                
                setNgayDangCSDT(item.ngayDangCSDT ? moment(item.ngayDangCSDT).format('YYYY-MM-DD') : '');
                setTruocSoNgayCSDT(item.truocSoNgayCSDT || '');
                setLinkDangTaiCSDT(item.linkDangTaiCSDT || '');

                setNgayDangQDND(item.ngayDangQDND ? moment(item.ngayDangQDND).format('YYYY-MM-DD') : '');
                setTruocSoNgayQDND(item.truocSoNgayQDND || '');
                setLinkDangTaiQDND(item.linkDangTaiQDND || '');
            }
        }
    }, [queryRes]);

    const handleSave = async () => {
        setSaving(true);
        try {
            const payload = {
                BaoVeCapVienId: baoVeCapVienId,
                KetQua: ketQua,
                
                NgayDangCSDT: ngayDangCSDT || null,
                TruocSoNgayCSDT: truocSoNgayCSDT ? parseInt(truocSoNgayCSDT) : null,
                LinkDangTaiCSDT: linkDangTaiCSDT || '',

                NgayDangQDND: ngayDangQDND || null,
                TruocSoNgayQDND: truocSoNgayQDND ? parseInt(truocSoNgayQDND) : null,
                LinkDangTaiQDND: linkDangTaiQDND || ''
            };

            if (congBoThongTinId) {
                await Put(CONGBOTHONGTIN_API.UPDATE_ITEM, congBoThongTinId, { ...payload, Id: congBoThongTinId });
            } else {
                await Post(CONGBOTHONGTIN_API.CREATE, null, payload);
            }

            toast.success('Lưu thông tin thành công!');
            await refetch();
        } catch (error) {
            console.error(error);
            toast.error('Có lỗi xảy ra khi lưu kết quả.');
        } finally {
            setSaving(false);
        }
    };

    if (isLoading) return <div className="text-center p-3"><Spinner animation="border" variant="primary" /></div>;

    return (
        <div className="bg-white p-3 rounded">
            <Card className="mb-3 border-info shadow-sm">
                <Card.Header className="bg-info text-white font-weight-bold">1. Thông tin chung</Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={12} className="mb-3">
                            <Form.Group>
                                <Form.Label className="font-weight-bold"><span className="text-danger">1.</span> Kết quả</Form.Label>
                                <div style={{ pointerEvents: (readOnly || isUserView) ? 'none' : 'auto' }}>
                                    <Form.Check 
                                        inline
                                        type="radio"
                                        label="Đạt"
                                        name="ketQuaThongTin"
                                        checked={ketQua === loaiDanhGiaValue.dat}
                                        onChange={() => { if (!readOnly && !isUserView) setKetQua(loaiDanhGiaValue.dat); }}
                                        tabIndex={readOnly || isUserView ? -1 : 0}
                                    />
                                    <Form.Check 
                                        inline
                                        type="radio"
                                        label="Không đạt"
                                        name="ketQuaThongTin"
                                        checked={ketQua === loaiDanhGiaValue.khongDat}
                                        onChange={() => { if (!readOnly && !isUserView) setKetQua(loaiDanhGiaValue.khongDat); }}
                                        tabIndex={readOnly || isUserView ? -1 : 0}
                                    />
                                </div>
                            </Form.Group>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <Card className="mb-3 border-success shadow-sm">
                <Card.Header className="bg-success text-white font-weight-bold">2. Web cơ sở đào tạo</Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={6} className="mb-3">
                            <Form.Group>
                                <Form.Label className="font-weight-bold"><span className="text-danger">1.</span> Ngày đăng</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={ngayDangCSDT}
                                    onChange={(e) => setNgayDangCSDT(e.target.value)}
                                    disabled={readOnly || isUserView}
                                    className={readOnly || isUserView ? "bg-white" : ""}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6} className="mb-3">
                            <Form.Group>
                                <Form.Label className="font-weight-bold"><span className="text-danger">2.</span> Số ngày đăng trước ngày bảo vệ</Form.Label>
                                <Form.Control
                                    type="number"
                                    value={truocSoNgayCSDT}
                                    onChange={(e) => setTruocSoNgayCSDT(e.target.value)}
                                    placeholder="Nhập số ngày..."
                                    disabled={readOnly || isUserView}
                                    className={readOnly || isUserView ? "bg-white" : ""}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={12} className="mb-3">
                            <Form.Group>
                                <Form.Label className="font-weight-bold"><span className="text-danger">3.</span> Link thông tin đăng tải</Form.Label>
                                <InputGroup>
                                    <Form.Control
                                        type="text"
                                        value={linkDangTaiCSDT}
                                        onChange={(e) => setLinkDangTaiCSDT(e.target.value)}
                                        placeholder="Nhập link đăng tải..."
                                        disabled={readOnly || isUserView}
                                        className={readOnly || isUserView ? "bg-white" : ""}
                                    />
                                    {linkDangTaiCSDT && (
                                        <InputGroup.Append>
                                            <a 
                                                href={linkDangTaiCSDT.startsWith('http') ? linkDangTaiCSDT : `http://${linkDangTaiCSDT}`} 
                                                target="_blank" 
                                                rel="noreferrer" 
                                                className="btn btn-outline-primary"
                                                title="Mở link đăng tải"
                                            >
                                                <i className="fas fa-external-link-alt"></i>
                                            </a>
                                        </InputGroup.Append>
                                    )}
                                </InputGroup>
                            </Form.Group>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <Card className="mb-3 border-warning shadow-sm">
                <Card.Header className="bg-warning text-white font-weight-bold">3. Trên báo Quân đội nhân dân</Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={6} className="mb-3">
                            <Form.Group>
                                <Form.Label className="font-weight-bold"><span className="text-danger">1.</span> Ngày đăng</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={ngayDangQDND}
                                    onChange={(e) => setNgayDangQDND(e.target.value)}
                                    disabled={readOnly || isUserView}
                                    className={readOnly || isUserView ? "bg-white" : ""}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6} className="mb-3">
                            <Form.Group>
                                <Form.Label className="font-weight-bold"><span className="text-danger">2.</span> Số ngày đăng trước ngày bảo vệ</Form.Label>
                                <Form.Control
                                    type="number"
                                    value={truocSoNgayQDND}
                                    onChange={(e) => setTruocSoNgayQDND(e.target.value)}
                                    placeholder="Nhập số ngày..."
                                    disabled={readOnly || isUserView}
                                    className={readOnly || isUserView ? "bg-white" : ""}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={12} className="mb-3">
                            <Form.Group>
                                <Form.Label className="font-weight-bold"><span className="text-danger">3.</span> Link thông tin đăng tải</Form.Label>
                                <InputGroup>
                                    <Form.Control
                                        type="text"
                                        value={linkDangTaiQDND}
                                        onChange={(e) => setLinkDangTaiQDND(e.target.value)}
                                        placeholder="Nhập link đăng tải..."
                                        disabled={readOnly || isUserView}
                                        className={readOnly || isUserView ? "bg-white" : ""}
                                    />
                                    {linkDangTaiQDND && (
                                        <InputGroup.Append>
                                            <a 
                                                href={linkDangTaiQDND.startsWith('http') ? linkDangTaiQDND : `http://${linkDangTaiQDND}`} 
                                                target="_blank" 
                                                rel="noreferrer" 
                                                className="btn btn-outline-primary"
                                                title="Mở link đăng tải"
                                            >
                                                <i className="fas fa-external-link-alt"></i>
                                            </a>
                                        </InputGroup.Append>
                                    )}
                                </InputGroup>
                            </Form.Group>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {!readOnly && !isUserView && (
                <div className="text-right mt-4">
                    <Button variant="success" onClick={() => handleSave()} disabled={saving}>
                        {saving ? <Spinner size="sm" animation="border" className="mr-1" /> : <i className="fas fa-save mr-1"></i>}
                        Lưu thông tin
                    </Button>
                </div>
            )}
        </div>
    );
};

export default CongBoThongTinForm;
